$(document).on('nc.sidePanel.shown', '[id^="data-side-panel-"]', function (sidePanel) {
    let field = sidePanel.target.querySelector('input#search, input#filter');

    if (field == null) {
        field = sidePanel.target.querySelector('input:not([type=hidden],[type=submit])');
    }

    if (field == null) {
        return;
    }

    try {
        const end = field.value.length;
        field.setSelectionRange(0,end);
        field.focus();
    } catch (e) {
        // do nothing
    }

})
